import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import OptionsContainer from '../../../../components/OptionsContainer';

const CheckboxInput = ({
  name,
  checked,
  onChange,
  disabled,
  message,
  messageId,
}) => (
  <OptionsContainer>
    <input
      disabled={disabled}
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
      className={disabled ? 'checkbox-readonly' : ''}
    />
    <span>
      <FormattedMessage {...message} id={messageId} />
    </span>
  </OptionsContainer>
);

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  message: PropTypes.object.isRequired,
  messageId: PropTypes.string,
};

CheckboxInput.defaultProps = {
  disabled: false,
  messageId: null,
};

export default CheckboxInput;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/CheckboxInput.js